// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

/* eslint-disable */

/**
 * This is a automatically generated component, do not edit it.
 * If you need to edit this component, move it to some other folder.
 */

import * as React from 'react';
import svg, { path } from 'react-native-svg';
function DrugIcon20(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        d="M16 10.137a.334.334 0 0 0-.334.333v1.373a.333.333 0 1 0 .667 0V10.47a.334.334 0 0 0-.334-.333ZM16 13.334a.334.334 0 0 0-.334.333v1.367a.333.333 0 1 0 .667 0v-1.367a.333.333 0 0 0-.334-.333ZM16 16.518a.334.334 0 0 0-.334.333v1.373a.333.333 0 1 0 .667 0v-1.373a.333.333 0 0 0-.334-.333ZM16 19.707a.333.333 0 0 0-.334.333v1.374a.333.333 0 1 0 .667 0V20.04a.333.333 0 0 0-.334-.333ZM16 22.896a.334.334 0 0 0-.334.334v1.373a.334.334 0 1 0 .667 0V23.23a.333.333 0 0 0-.334-.334ZM25.54 25.947h-2.607a.334.334 0 0 0 0 .667h2.607a.333.333 0 1 0 0-.667ZM9 25.947H6.385a.333.333 0 1 0 0 .667H9a.333.333 0 1 0 0-.667Z"
      />
      <path
        fill="currentColor"
        d="M31.667 6.95a2.387 2.387 0 0 1-2.384-2.386v-2.02a1.247 1.247 0 0 0-1.26-1.243h-8.396a1.25 1.25 0 0 0-1.247 1.243v1.91c0 2.177-2.513 3.303-4.037 1.823a2.37 2.37 0 0 1-.723-1.713v-2.02a1.25 1.25 0 0 0-1.247-1.243H3.977A1.25 1.25 0 0 0 2.73 2.544v2.02A2.387 2.387 0 0 1 .333 6.951.333.333 0 0 0 0 7.284v20.51a.333.333 0 0 0 .333.334 2.239 2.239 0 0 1 2.254 2.24.333.333 0 0 0 .333.333h10.507a.333.333 0 0 0 .333-.334 2.24 2.24 0 1 1 4.48 0 .333.333 0 0 0 .333.334H29.08a.333.333 0 0 0 .333-.334 2.24 2.24 0 0 1 2.254-2.24.333.333 0 0 0 .333-.333V7.284a.333.333 0 0 0-.333-.333Zm-.334 20.527a2.91 2.91 0 0 0-2.556 2.557h-9.89a2.91 2.91 0 0 0-2.554-2.553v-1.06a.333.333 0 1 0-.666 0v1.06a2.91 2.91 0 0 0-2.554 2.553H3.237a2.91 2.91 0 0 0-2.57-2.556V7.598a3.053 3.053 0 0 0 2.716-3.034v-2.02a.58.58 0 0 1 .594-.577h8.396a.58.58 0 0 1 .58.577v2.02a3.034 3.034 0 0 0 2.714 3.027v1.076a.333.333 0 1 0 .666 0V7.591a3.137 3.137 0 0 0 2.714-3.137v-1.91a.58.58 0 0 1 .58-.577h8.396a.58.58 0 0 1 .58.577v2.02a3.054 3.054 0 0 0 2.73 3.033v19.88Z"
      />
      <path
        fill="currentColor"
        d="M10 8.44a2.62 2.62 0 0 0-4.583 0L4.57 9.97a6.143 6.143 0 0 0-.696 3.903l1.383 8.95a1 1 0 0 0 .957.844h2.953a.98.98 0 0 0 .976-.837l1.384-8.95a6.143 6.143 0 0 0-.697-3.903L10 8.44Zm.883 5.333-1.4 8.95a.334.334 0 0 1-.316.27H6.214a.334.334 0 0 1-.314-.27L4.517 13.77a5.487 5.487 0 0 1 .62-3.477L6 8.76a1.957 1.957 0 0 1 3.417 0l.847 1.533a5.493 5.493 0 0 1 .603 3.48h.016ZM26.526 8.44a2.617 2.617 0 0 0-4.58 0l-.85 1.53a6.163 6.163 0 0 0-.693 3.904l1.383 8.95a.98.98 0 0 0 .973.843h2.954a1 1 0 0 0 .976-.837l1.38-8.95a6.163 6.163 0 0 0-.693-3.903l-.85-1.537Zm.887 5.334-1.384 8.95a.334.334 0 0 1-.333.27H22.76a.334.334 0 0 1-.333-.27l-1.367-8.95a5.494 5.494 0 0 1 .607-3.48l.85-1.534a1.954 1.954 0 0 1 3.413 0l.85 1.534a5.494 5.494 0 0 1 .634 3.48Z"
      />
    </svg>
  );
}
export default DrugIcon20;
